import currency from 'currency.js';

/**
 * Return and object to handle money expressed in floating point number.
 *
 */
export const money = currency;
